<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Ficha de Atividade Coletiva"
            description="Ficha de Atividade Coletiva"
            url="/oficinas-treinamentos"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import Footer from "@/components/Footer";
import SectionTitle from "@/components/SectionTitle";

export default {
  components: { Menu, Footer, SectionTitle },
};
</script>

<style></style>